/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
  InputAdornment,
  TextField,
  LinearProgress,
  Typography,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import "./style.css";
import { ZyppLiteApi } from "../../../API/Zypp-Lite-Api/LiteApi";

const IotDisconnected = () => {
  const [searchValInput, setSearchValInput] = useState("");
  const [page, setPage] = useState(0);
  const [totalCount, setTotalCount] = useState<any>();
  const [evDetailListData, setEvDetailListData] = useState<any[]>([]);
 
  const rowsPerPage = 10;
  const pageRange = 5;

  const tableHeaderCellStyle = {
    fontWeight: 600,
    fontSize: "14px",
    color: "#455A64",
    font: "Rubik",
  };
  const tableBodyCellStyle = {
    fontWeight: 400,
    fontSize: "14px",
    color: "#3b3b3b",
    font: "Rubik",
  };
  // Dummy data for tables

  const pageCount = Math.ceil(totalCount / rowsPerPage);
  const handlePageChange = (newPage: number) => {
    const newPageNumber = Math.max(1, Math.min(newPage + 1, pageCount));
    setPage(newPageNumber - 1);
  };

  const evDeatailList = () => {
    ZyppLiteApi.api
      ?.iotDisconnectedList(searchValInput, page, rowsPerPage)
      .then((response) => {
        if (response.data.vehicleDisconnectedResponse.length > 0) {
          setEvDetailListData(response.data.vehicleDisconnectedResponse);
          setTotalCount(response.data.total);
        } else {
          setEvDetailListData([]);
          setTotalCount(1);
        }
      })
      .catch((error) => {
        console.error("API call error: ", error);
      });
  };
  useEffect(() => {
    evDeatailList();
  }, [page, rowsPerPage, searchValInput]);

  const renderPageNumbers = () => {
    const pagesToShow = Math.min(pageCount, pageRange);
    const startPage = Math.max(
      0,
      Math.min(page - Math.floor(pageRange / 2), pageCount - pagesToShow)
    );

    return Array.from({ length: pagesToShow }, (_, index) => {
      const pageNumber = startPage + index + 1;
      return (
        <span
          key={index}
          onClick={() => handlePageChange(pageNumber - 1)}
          className={page === pageNumber - 1 ? "active" : "unactive"}
          style={{ marginLeft: "6px" }}
        >
          {pageNumber}
        </span>
      );
    });
  };
  const handleClearSearch = () => {
    setSearchValInput("");
  };

  

  return (
    <div className="p-1">
      <div className="w-full flex bg-white min-h-80 box-shadow p-3 rounded-xl p-4">
        <div className="w-full">
          <Grid container spacing={5} className="w-full flex justify-between ">
            <Grid item md={3}>
              <div className="flex ml-4">
                <h2 className="text-center ml-2 mx-1 mt-2 font-semibold text-2xl text-black pb-2">
                  IOT Details
                </h2>
              </div>
            </Grid>
            <Grid item md={9}>
              <div className="flex mr-4">
                <div className="flex w-full justify-end">
                  <div className="mr-3">
                    <TextField
                      placeholder="Search  Vehicle Number"
                      id="outlined-basic"
                      variant="outlined"
                      onChange={(search: any) =>
                        setSearchValInput(search.target.value)
                      }
                      value={searchValInput}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon />
                          </InputAdornment>
                        ),
                        endAdornment: (
                          <InputAdornment
                            position="end"
                            onClick={handleClearSearch}
                          >
                            <ClearIcon style={{ cursor: "pointer" }} />
                          </InputAdornment>
                        ),
                        style: { height: "40px", borderRadius: "25px" },
                      }}
                      // onKeyDown={handleKeyPress}
                    />
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
          <hr className="my-4" />

          <TableContainer style={{ width: "100%", overflowX: "auto" }}>
            {!evDetailListData ? ( // Check if API response is still undefined (loading)
              <LinearProgress />
            ) : typeof evDetailListData === "string" ? ( // If API returns "No Data Found" as a string
              <Typography style={{ textAlign: "center", padding: "10px" }}>
                No data available
              </Typography>
            ) : evDetailListData.length === 0 ? ( // If the array is empty
              <Typography style={{ textAlign: "center", padding: "10px" }}>
                No data available
              </Typography>
            ) : (
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell
                      style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                      sx={{ minWidth: 120 }}
                    >
                      Vehicle No
                    </TableCell>
                    <TableCell
                      style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                      sx={{ minWidth: 150 }}
                    >
                      Last Updated At
                    </TableCell>
                    <TableCell
                      style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                      sx={{ minWidth: 150 }}
                    >
                      Latitude
                    </TableCell>
                    <TableCell
                      style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                      sx={{ minWidth: 110 }}
                    >
                      Longitude
                    </TableCell>
                    <TableCell
                      style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                      sx={{ minWidth: 110 }}
                    >
                      userId
                    </TableCell>
                    <TableCell
                      style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                      sx={{ minWidth: 130 }}
                    >
                      mobile
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {evDetailListData.map((item: any, index: any) => (
                    <TableRow key={index}>
                      <TableCell
                        style={{ ...tableBodyCellStyle, textAlign: "center" }}
                      >
                        {item.vehicleNo}
                      </TableCell>
                      <TableCell
                        style={{ ...tableBodyCellStyle, textAlign: "center" }}
                      >
                        {item.lastUpdatedAt}
                      </TableCell>
                      <TableCell
                        style={{ ...tableBodyCellStyle, textAlign: "center" }}
                      >
                        {item.latitude}
                      </TableCell>
                      <TableCell
                        style={{ ...tableBodyCellStyle, textAlign: "center" }}
                      >
                        {item.longitude}
                      </TableCell>
                      <TableCell
                        style={{ ...tableBodyCellStyle, textAlign: "center" }}
                      >
                        {item.userId}
                      </TableCell>
                      <TableCell
                        style={{ ...tableBodyCellStyle, textAlign: "center" }}
                      >
                        {item.mobile}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            )}
          </TableContainer>

          <div className="pl-2 pt-4 pb-2 pr-16">
            <div
              className="pagination"
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <div>
                <button
                  onClick={() => handlePageChange(page - 1)}
                  disabled={page === 0}
                  style={{
                    fontFamily: "Rubik",
                    fontSize: "20px",
                    marginRight: "6px",
                  }}
                >
                  {"<"}
                </button>
                {renderPageNumbers()}
                <button
                  onClick={() => handlePageChange(page + 1)}
                  disabled={page >= pageCount - 1}
                  style={{
                    fontFamily: "Rubik",
                    fontSize: "20px",
                    marginLeft: "6px",
                  }}
                >
                  {">"}
                </button>
              </div>
            </div>
          </div>
        </div>
       
       
      </div>
    </div>
  );
};

export default IotDisconnected;
